/* Wishlist hearts tweak */
window.addEventListener('DOMContentLoaded', function() {
  const wishlistHearts = document.querySelectorAll('.iWishAddColl');
  const wishlistProducts = localStorage.getItem('iWishlistmain');
  for (const wishlistHeart of wishlistHearts) {
    if (wishlistProducts?.includes(wishlistHeart.dataset.product)) {
      wishlistHeart.classList.add('iwishAdded');
    }
  }
});

/* Collection read more */
window.addEventListener('DOMContentLoaded', function() {
  const collectionTextContainer = document.querySelector('.collection-text--container');

  if (collectionTextContainer) {
    const accordionButton = collectionTextContainer.querySelector('svg');
    const collectionText = collectionTextContainer.querySelector('.collection-text');
    const collectionTextInner = collectionTextContainer.querySelector('.metafield-rich_text_field');

    accordionButton.addEventListener('click', function() {
      if (collectionTextContainer.classList.contains('open')) {
        collectionTextContainer.classList.remove('open');
        collectionText.style.height = 50 + 'px';
      } else {
        collectionTextContainer.classList.add('open');
        collectionText.style.height = collectionTextInner.offsetHeight + 'px';
      }
    });
  }
});

/* Tidio fix */
window.addEventListener('DOMContentLoaded', function() {
  const tidioChat = document.querySelector('#tidio-chat');
  if (tidioChat) {
    tidioChat.style.removeProperty('z-index');
  } else {
    const mutationObserver = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          for (let node of mutation.addedNodes) {
            if (node.id === 'tidio-chat') {
              node.style.removeProperty('z-index');
              observer.disconnect();
              return;
            }
          }
        }
      }
    });

    const config = { childList: true };
    mutationObserver.observe(document.body, config);
  }
});